import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const addUserToProject = api(({ userId, projectId, roles, clientId } = {}) =>
    mutate(
        gql`
            mutation AddUserToProject($userId: String!, $projectId: String!, $roles: [String], $clientId: String) {
                addUserToProject(userId: $userId, projectId: $projectId, clientId: $clientId, roles: $roles) {
                    UserName
                }
            }
        `,
        { userId, projectId, roles, clientId },
        { returns: "addUserToProject" }
    )
)
